import React, { useMemo } from 'react';
import { Case } from '../../../../graphql/graphql';
import DataTable, {
	DataTableColumn,
} from '../../../Base/Components/DataTable/DataTable';

export interface MonitoringCenterCase extends Case {
	assignedDoctorShortedName: string;
}

export interface MonitoringCenterTable {
	refresh: () => void;
}

interface Props {
	data: Case[];
	table: MonitoringCenterTable;
	columns: DataTableColumn<MonitoringCenterCase, MonitoringCenterTable>[];
}

const MonitoringCenterListTable: React.FC<Props> = ({
	data,
	table,
	columns,
}) => {
	const alternatedData = useMemo(
		() =>
			data.map(item => ({
				...item,
				assignedDoctorShortedName: `${
					item.doctor?.profile?.salutationBefore ?? ''
				} ${item.doctor?.profile?.lastName ?? ''}`.trim(),
			})),
		[data],
	);

	return (
		<DataTable<MonitoringCenterCase, MonitoringCenterTable>
			data={alternatedData}
			table={table}
			columns={columns}
		/>
	);
};

export default MonitoringCenterListTable;
